// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"cd13380d","21":"218f11ea","638":"11f53583","670":"57390d41","735":"35235090","968":"8730d4b4"}[chunkId] + ".css";
};